import { render, staticRenderFns } from "./TheExperimentDetail.vue?vue&type=template&id=144bb0d4&"
import script from "./TheExperimentDetail.vue?vue&type=script&lang=js&"
export * from "./TheExperimentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports